module.exports = __webpack_public_path__ + "6d565f554e669c3ef8ae6ae87199af1b.png";